<template>
  <div class="container">
    <div @click="goback()">
      <div class="navi">
          <span class="icon-arrow-left"></span>
      </div>
    </div>
    <div class="title" v-if="orderDetail.sync_type=='1'">仓储入库详情</div>
    <div class="title" v-if="orderDetail.sync_type=='2'">仓储出库详情</div>
    <div class="title" v-if="orderDetail.sync_type=='3'">存储收费详情</div>
    <div class="title" v-if="orderDetail.sync_type=='4'">仓储续期详情</div>

    <div class="weui-msg__text-area">
        <h2 class="weui-msg__title">订单号：WS{{orderDetail.sync_id}} </h2>
        <h2 class="weui-msg__title">订单状态：{{orderDetail.order_status_name}}</h2>
    </div>

    <div v-if="orderType()=='selfpick'">
      <div class="notice-yellow">
          请在预约时间将货物送往仓库
      </div>
      <div class="weui-cells">
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>入库模式</p>
            </div>
            <div class="weui-cell__ft">自行送往 - {{orderDetail.details.in_address.in_suburb}} 仓库</div>
        </a>
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>预约时间</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.service_date| moment("YYYY年M月D日")}} {{orderDetail.service_time}} </div>
        </a>
      </div>
      <div class="weui-panel">
          <div class="weui-panel__hd">📍{{orderDetail.details.in_address.in_suburb}} 仓库地址（点击在地图上打开）</div>
          <div class="weui-panel__bd">
              <div class="weui-media-box weui-media-box_small-appmsg">
                  <div class="weui-cells">
                      <a class="weui-cell weui-cell_active weui-cell_access weui-cell_example" href="https://maps.google.com/?q=4/63+Norman+St,+Peakhurst+NSW+2210+Australia" target="_blank" v-if="orderDetail.details.in_address.in_suburb=='Peakhurst'">
                          <div class="weui-cell__bd weui-cell_primary">
                              <p>Peakhurst 仓库</p>
                              <p class="weui-media-box__desc">4/63 Norman St, Peakhurst NSW 2210 </p>
                          </div>
                          <span class="weui-cell__ft"></span>
                      </a>
                      <a class="weui-cell weui-cell_active weui-cell_access weui-cell_example" href="https://maps.google.com/?q=38/7+Percy+Street,+Auburn+NSW+2144+Australia" target="_blank" v-if="orderDetail.details.in_address.in_suburb=='Auburn'">
                          <div class="weui-cell__bd weui-cell_primary">
                              <p>Auburn 仓库</p>
                              <p class="weui-media-box__desc">38/7 Percy Street, Auburn NSW 2144 </p>
                          </div>
                          <span class="weui-cell__ft"></span>
                      </a>
                  </div>
              </div>
          </div>
      </div>
    </div>

    <div v-if="orderType()=='selfreturn'">
      <div class="notice-yellow">
          请在预约时间来到仓库提取货物
      </div>
      <div class="weui-cells">
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>出库模式</p>
            </div>
            <div class="weui-cell__ft">自行取货 - {{orderDetail.details.in_address.in_suburb}} 仓库</div>
        </a>
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>预约时间</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.service_date| moment("YYYY年M月D日")}} {{orderDetail.service_time}} </div>
        </a>
      </div>
      <div class="weui-panel">
          <div class="weui-panel__hd">📍{{orderDetail.details.in_address.in_suburb}} 仓库地址（点击在地图上打开）</div>
          <div class="weui-panel__bd">
              <div class="weui-media-box weui-media-box_small-appmsg">
                  <div class="weui-cells">
                      <a class="weui-cell weui-cell_active weui-cell_access weui-cell_example" href="https://maps.google.com/?q=4/63+Norman+St,+Peakhurst+NSW+2210+Australia" target="_blank" v-if="orderDetail.details.in_address.in_suburb=='Peakhurst'">
                          <div class="weui-cell__bd weui-cell_primary">
                              <p>Peakhurst 仓库</p>
                              <p class="weui-media-box__desc">4/63 Norman St, Peakhurst NSW 2210 </p>
                          </div>
                          <span class="weui-cell__ft"></span>
                      </a>
                      <a class="weui-cell weui-cell_active weui-cell_access weui-cell_example" href="https://maps.google.com/?q=38/7+Percy+Street,+Auburn+NSW+2144+Australia" target="_blank" v-if="orderDetail.details.in_address.in_suburb=='Auburn'">
                          <div class="weui-cell__bd weui-cell_primary">
                              <p>Auburn 仓库</p>
                              <p class="weui-media-box__desc">38/7 Percy Street, Auburn NSW 2144 </p>
                          </div>
                          <span class="weui-cell__ft"></span>
                      </a>
                  </div>
              </div>
          </div>
      </div>
    </div>

    <div v-if="orderType()=='store'">
      <div class="weui-cells">
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>仓储体积</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.storage_scale_name}}</div>
        </a>
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>入库时间</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.service_date| moment("YYYY年M月D日")}}</div>
        </a>
      </div>
      <div class="weui-cells">
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>每周费用</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.storage_scale_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>存储周数</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.estimated_week}}周</div>
        </a>
        <a class="weui-cell" href="javascript:;" v-if="orderDetail.gst_amount>0">
            <div class="weui-cell__bd">
                <p>GST费用</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.gst_amount | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" v-if="orderDetail.other_amount>0">
            <div class="weui-cell__bd">
                <p>其他费用</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.other_amount | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" v-if="orderDetail.offers_amount>0">
            <div class="weui-cell__bd">
                <p>优惠金额</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.offers_amount | numeral('$0,0.00')}}</div>
        </a>
      </div>
    </div>
    <div class="weui-cells" v-if="orderDetail.payment_amount>0">
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>待付金额</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.payment_amount | numeral('$0,0.00')}}</div>
        </a>
    </div>
    <div v-if="orderType()=='renew'">
      <div class="weui-cells">
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>仓储体积</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.storage_scale_name}}，{{orderDetail.details.storage_scale_cost| numeral('$0,0.00')}} / 每周</div>
        </a>
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>续期周数</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.renewal_week}}周 </div>
        </a>
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>续期费用</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.renewal_cost | numeral('$0,0.00')}} </div>
        </a>
      </div>
    </div>


    <div class="weui-cells__title" v-if="orderDetail.pay_status==3||orderDetail.pay_status==4">费用详情</div>

    <div class="weui-cells" v-if="orderDetail.pay_status==3||orderDetail.pay_status==4">
      <a class="weui-cell" href="javascript:;" >
          <div class="weui-cell__bd">
              <p>总费用</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.order_amount | numeral('$0,0.00')}}</div>
      </a>
    </div>


    <div class="weui-cells__title" v-if="orderType()=='pick' || orderType()=='return'">基本信息</div>
    <div class="weui-cells"  v-if="orderType()=='pick' || orderType()=='return'">
      <a class="weui-cell" href="javascript:;" v-if="orderType()=='pick'">
          <div class="weui-cell__bd" >
              <p>联系人</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.out_address.out_name}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderType()=='pick'">
          <div class="weui-cell__bd">
              <p>联系手机</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.out_address.out_phone}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderType()=='pick'">
          <div class="weui-cell__bd">
              <p>取货时间</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.service_date | moment("YYYY年M月D日")}} {{orderDetail.service_time}}</div>
      </a>
      <a class="weui-cell" href="javascript:;"v-if="orderType()=='pick'">
          <div class="weui-cell__bd">
              <p>取货地址</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.out_address.out_street}}, {{orderDetail.details.out_address.out_suburb}}, {{orderDetail.details.out_address.out_state}}, {{orderDetail.details.out_address.out_postcode}}</div>
      </a>
      
      <a class="weui-cell" href="javascript:;" v-if="orderType()=='return'">
          <div class="weui-cell__bd" >
              <p>联系人</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.in_address.in_name}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderType()=='return'">
          <div class="weui-cell__bd">
              <p>联系手机</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.in_address.in_phone}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderType()=='return'">
          <div class="weui-cell__bd">
              <p>送回地址</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.in_address.in_street}}, {{orderDetail.details.in_address.in_suburb}}, {{orderDetail.details.in_address.in_state}}, {{orderDetail.details.in_address.in_postcode}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderType()=='return'">
          <div class="weui-cell__bd">
              <p>送回时间</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.service_date | moment("YYYY年M月D日")}} {{orderDetail.service_time}}</div>
      </a>

    </div>
    <div class="weui-cells__title" v-if="(orderType()=='pick' || orderType()=='return') && orderDetail.details.labor_cost>0">价格细节</div>

    <div class="weui-cells"  v-if="orderType()=='pick'">
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.details.labor_cost>0">
          <div class="weui-cell__bd">
              <p>基础服务费</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.labor_cost | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;"  v-if="orderDetail.details.return_trip_cost>0">
          <div class="weui-cell__bd">
              <p>出车回程费</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.return_trip_cost | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.details.stairs_cost>0">
          <div class="weui-cell__bd">
              <p>楼梯费</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.stairs_cost | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;"  v-if="orderDetail.details.wait_cost>0">
          <div class="weui-cell__bd">
              <p>超时等待费</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.wait_cost | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.details.weight_cost>0">
          <div class="weui-cell__bd">
              <p>重物费</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.weight_cost | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.details.etoll_cost>0">
          <div class="weui-cell__bd">
              <p>高速费用</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.etoll_cost | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.gst_amount>0">
          <div class="weui-cell__bd">
              <p>GST费用</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.gst_amount | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.other_amount>0">
          <div class="weui-cell__bd">
              <p>其他费用</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.other_amount | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.offers_amount>0">
          <div class="weui-cell__bd">
              <p>优惠金额</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.offers_amount | numeral('$0,0.00')}}</div>
      </a>
    </div>

    <div class="weui-cells"  v-if="orderType()=='return'">
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.details.labor_cost>0">
          <div class="weui-cell__bd">
              <p>基础服务费</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.labor_cost | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;"  v-if="orderDetail.details.return_trip_cost>0">
          <div class="weui-cell__bd">
              <p>出车回程费</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.return_trip_cost | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.details.stairs_cost>0">
          <div class="weui-cell__bd">
              <p>楼梯费</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.stairs_cost | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.details.weight_cost>0">
          <div class="weui-cell__bd">
              <p>重物费</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.weight_cost | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.details.etoll_cost>0">
          <div class="weui-cell__bd">
              <p>高速费用</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.etoll_cost | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.gst_amount>0">
          <div class="weui-cell__bd">
              <p>GST费用</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.gst_amount | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" >
          <div class="weui-cell__bd">
              <p>其他费用</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.other_amount | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.offers_amount>0">
          <div class="weui-cell__bd">
              <p>优惠金额</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.offers_amount | numeral('$0,0.00')}}</div>
      </a>
    </div>
    <div class="btn-box-fix" v-if="orderDetail.pay_status==0||orderDetail.pay_status==2">
      <div class="btn-container">
        <div class="btn active" @click="checkSubmit()">立即支付</div>
      </div>
    </div>


    <transition name="fade">
        <div id="loadingToast" v-show="isSending">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <i class="weui-loading weui-icon_toast"></i>
                <p class="weui-toast__content">正在获取订单</p>
            </div>
        </div>
    </transition>

  </div>

</template>

<script>
import qs from 'qs'

export default {
  name: 'order-detail',
  data () {
    return {
      isSending:false,
      isSendingPricing:false,
      orderDetail:{
        "order_id": "",
        "type_id": "",
        "order_number": "",
        "member_id": "",
        "member_name": "",
        "member_phone": "",
        "member_mail": "",
        "service_date": "",
        "service_time": "",
        "deposit_amount": "",
        "offers_amount": "",
        "other_amount": "",
        "payment_amount": "",
        "order_amount": "",
        "gst_amount": "",
        "cancelfee_amount": "",
        "order_status": "",
        "pay_status": "",
        "prepaid_time": "",
        "pay_time": "",
        "created": "",
        "operates": "",
        "other_amount_data": "",
        "invoices_url": "",
        "type_name": "",
        "order_status_name": "",
        "pay_status_name": "",
        "cost_data": {
            "operates_num": 0
        },
        "details": {
            "student_plan": "",
            "baggage": "",
            "in_address": {
                "pick_street": "",
                "pick_suburb": "",
                "pick_state": "",
                "pick_postcode": ""
            },
            "pick_date": "",
            "pick_time": "",
            "pick_period": "",
            "return_address": {
                "return_street": "",
                "return_suburb": "",
                "return_state": "",
                "return_postcode": ""
            },
            "return_date": "",
            "return_time": "",
            "return_period": "",
            "contact_bak": "",
            "return_pending": "",
            "student_plan_name": ""
        },
        "expiration_time": 0,
        "lifecycle_text": "",
        "lifecycle_status": 0
      }
    }
  },
  methods: {

    orderType: function () {
      if(this.orderDetail.sync_type=='1' && this.orderDetail.is_self=='1'){
        return 'selfpick';
      }
      if(this.orderDetail.sync_type=='2' && this.orderDetail.is_self=='1'){
        return 'selfreturn';
      }
      if(this.orderDetail.sync_type=='1' && this.orderDetail.is_self!='1'){
        return 'pick';
      }
      if(this.orderDetail.sync_type=='2' && this.orderDetail.is_self!='1'){
        return 'return';
      }
      if(this.orderDetail.sync_type=='3'){
        return 'store';
      }
      if(this.orderDetail.sync_type=='4'){
        return 'renew';
      }
    },

    getData(){
      if(this.isSending){
        return false;
      }
      else{
        let dataObject={};
        let that = this;
        this.isSending = true;
        dataObject.order_number = this.$route.query.id;
        dataObject.token = localStorage.token;

        this.axios.post(this.apiURL()+'/Order/storageInfo', qs.stringify(dataObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.isSending = false;
            that.orderDetail = response.data.data;
            console.log(that.orderDetail)

          }
          else{
            if(!that.checkLogin()){
              that.$router.push('/login');
            }
            that.isSending=false;
          }
        })
        .catch(function (error) {
            console.log(error)
            alert("订单获取失败，请检查网络并重新尝试")
            that.isSending=false;
        });
      }
    },
    checkSubmit(){
      if(this.orderDetail.pay_status==0){
        this.$router.push('/order-prepay?id='+this.$route.query.id+'&subtype=ws&status=0&amount='+this.depositAmount());
      }
      if(this.orderDetail.pay_status==2){
        this.$router.push('/order-prepay?id='+this.$route.query.id+'&subtype=ws&status=2&amount='+this.orderDetail.payment_amount);
      }
    },
    goback(){
      this.$router.push('/warehouse/order-detail?id='+ this.orderDetail.sync_order_number);
    },
  },
  components: {
  },
  computed: {
    orderIDFromURL: function (){
      let theString = this.$route.query.id;
      if(theString.includes("?")){
        return theString.substring(0, theString.indexOf('?'));
      }
      else{
        return theString;
      }
    },
    updateLink: function (){
      return "/storage/order-update?id="+this.$route.query.id;
    },
    pick_period: function () {
      let result = '';
      switch (this.orderDetail.details.pick_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("1");
      }
      return result;
    },
    return_period: function () {
      let result = '';
      switch (this.orderDetail.details.return_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("1");
      }
      return result;
    },
    pricingURL: function (){
      let theString = this.$route.query.id;
      return '/storage/order-detail/price?id=' + theString;
    },
    pricing: function () {
      let result = '';
      switch (this.orderDetail.details.student_plan) {
        case "1668743923":
          result = '298'
          break;
        case "1668743953":
          result = '428'
          break;
        case "1668743985":
          result = '568'
          break;
        case "1668744048":
          result = '688'
          break;
        default:
          console.log("1");
      }
      return result;
    },

  },
  created: function () {
    this.getData();
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container /deep/ {
  .weui-cell__ft{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width:70%;
    font-size:0.9em;
  }

  .weui-msg__title{
    font-size:1.1em;
    margin-bottom:0;
  }

  .park-assist{
      text-align:center;
      color:#fe9567;
  }

  .prepay-img{
    width:100%;
  }

  .notice-yellow{
    margin:-10px 20px 0 20px;
  }
} 

</style>



// WEBPACK FOOTER //
// src/pages/warehouse/order-detail-sub.vue